import { IEditSectionRequest } from 'core/model/interfaces/static-pages';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IStaticPagesState } from '../types';

export const editSection = createAppAsyncThunk(`${SLICE_NAMESPACE}/editSection`, async (data: IEditSectionRequest) => {
  try {
    await apiService.staticPages.editSection(data);
    notificationService.global.success('La sección ha sido modificada correctamente.');
  } catch (e) {
    const errorMessage = handleErrorMessage(e, 'Ocurrió un error al editar la sección.');
    showNotificationError(errorMessage);
    throw e;
  }
});

export const editSectionReducer: TSliceExtraReducer<IStaticPagesState> = builder =>
  builder
    .addCase(editSection.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(editSection.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(editSection.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
